import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { errorText } from "@/components/coaching/GuidedDay";

const STATUS = { starter: "Starting", bench: "Bench", out: "Not playing" };
const noteFor = (plan, p) => [`Game day: ${plan.title}${plan.date ? ` (${plan.date})` : ""}`, `Status: ${STATUS[p.status] || p.status}`, p.role && `Your role: ${p.role}`, p.notes && `Your job: ${p.notes}`].filter(Boolean).join("\n");

export const sendToAthlete = async (athleteId, text, clientId) => {
  const t = (await api.get(`/chat/athlete/${athleteId}/thread`)).data;
  if (!t.thread || !t.can_send) return { ok: false, why: "only their assigned coach can message them" };
  await api.post(`/chat/threads/${t.thread.thread_id}/messages`, { text, client_id: clientId });
  return { ok: true };
};

export const SendNotes = ({ plan }) => {
  const [busy, setBusy] = useState(false), [result, setResult] = useState(null);
  const players = plan.lineup.filter((p) => p.role || p.notes || p.status === "out");
  const send = async () => {
    setBusy(true);
    const out = [];
    for (const p of players) {
      try {
        out.push({ name: p.name, ...(await sendToAthlete(p.athlete_id, noteFor(plan, p), `gd-${plan.plan_id}-${p.athlete_id}-${plan.revision}`)) });
      } catch (e) { out.push({ name: p.name, ok: false, why: errorText(e) }); }
    }
    setResult(out); setBusy(false);
    const sent = out.filter((x) => x.ok).length;
    toast[sent === out.length ? "success" : "error"](`Sent to ${sent} of ${out.length} athletes`);
  };
  return (
    <div className="space-y-2" data-testid="gameday-send-notes">
      <Button variant="outline" data-testid="gameday-send-btn" disabled={busy || !players.length} onClick={send}>{busy ? "Sending…" : `Send each player their role and job (${players.length})`}</Button>
      {!players.length && <p className="text-xs text-muted-foreground">Give players a role or a job first, then save.</p>}
      {result && <ul className="text-xs space-y-1" data-testid="gameday-send-result">{result.map((r) => <li key={r.name} className={r.ok ? "text-traffic-green" : "text-traffic-red"}>{r.ok ? `${r.name}: sent` : `${r.name}: not sent, ${r.why}`}</li>)}</ul>}
    </div>
  );
};

export const Triggers = ({ rows, setRows }) => {
  const set = (i, k, v) => setRows(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  return (
    <div className="space-y-2" data-testid="gameday-triggers">
      {rows.map((t, i) => (
        <div key={i} className="grid sm:grid-cols-[1fr_1fr_auto] gap-2" data-testid={`gameday-trigger-${i}`}>
          <input data-testid={`gameday-trigger-${i}-sign`} className="inp" placeholder="If you see… e.g. their spinner on before over 7" value={t.sign} onChange={(e) => set(i, "sign", e.target.value)} />
          <input data-testid={`gameday-trigger-${i}-switch`} className="inp" placeholder="Switch to… e.g. sweep plan, left-hander up the order" value={t.switch_to} onChange={(e) => set(i, "switch_to", e.target.value)} />
          <button data-testid={`gameday-trigger-${i}-remove`} className="text-xs underline px-2" onClick={() => setRows(rows.filter((_, j) => j !== i))}>Remove</button>
        </div>))}
      <Button size="sm" variant="outline" data-testid="gameday-trigger-add" disabled={rows.length >= 20} onClick={() => setRows([...rows, { sign: "", switch_to: "" }])}>Add a sign to watch for</Button>
    </div>
  );
};
